import React, { FC } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'


import styles from './styles.module.scss'

interface IVariant {
  key: number,
  icons: React.ReactNode[],
  title: string,
  titleButton: string
  description: React.ReactNode
  variantNumber: React.ReactNode
}

interface IProps {
  variant: IVariant
}


export const HeadsetVariant: FC<IProps> = ({ variant }) => {

  return (
    <div className={styles.headsetVariant}>
      <div className={styles.icons}>
        {variant.icons.map((item, idx) => <React.Fragment key={idx}>{item}</React.Fragment>)}
      </div>
      <div className={styles.title}>{variant.title}</div>
      <div className={styles.description}>{variant.description}</div>
      <div className={styles.variantNumber}>
        {variant.variantNumber}
      </div>
    </div>
  )
}
